import { CampaignMonitorActionTypes } from './types/actions'
import { initState } from './types/reducer'
import {
  INTEGRATE_CAMPAIGN_MONITOR,
  INTEGRATE_CAMPAIGN_MONITOR_SUCCESS,
  INTEGRATE_CAMPAIGN_MONITOR_ERROR,
} from './constants'

export const initialState: initState = {
  isLoading: false,
  error: {
    message: '',
  },
  data: {
    campaignMonitor: {
      apiKey: '',
    },
  },
}

const reducer = (
  state: initState = initialState,
  action: CampaignMonitorActionTypes,
): initState => {
  switch (action.type) {
    case INTEGRATE_CAMPAIGN_MONITOR:
      return { ...state, isLoading: true }
    case INTEGRATE_CAMPAIGN_MONITOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case INTEGRATE_CAMPAIGN_MONITOR_ERROR:
      return {
        ...state,
        isLoading: false,
        error: {
          message: action.payload,
        },
      }

    default:
      return state
  }
}

export default reducer
